import { createFlagsSchema, schema, useRemoteConfig } from '@funtech-int/yango-shared';
import { useI18n as useI18nManager } from '@funtech-int/rival-react';

import { ShowcaseId } from '@/shared/lib/analytics/showcase';

const remoteConfigSchema = createFlagsSchema({
    loginwall_config: schema
        .create({
            backgroundImageUrl: schema.mapOf(schema.string).optional(),
            title: schema.mapOf(schema.string).optional(),
            subtitle: schema.mapOf(schema.string).optional(),
            loginwallShowcaseId: schema.enum(Object.values(ShowcaseId)).optional(),
            isLoginButtonEnabled: schema.boolean.optional(true),
        })
        .optional(),
});

type DefaultBackgroundUrls = Record<string, string> & { en: string };

export const useLoginwallMainSection = (defaultBackgroundUrls?: DefaultBackgroundUrls) => {
    const remoteConfig = useRemoteConfig(remoteConfigSchema);
    const { lang } = useI18nManager().locale.get();
    const langKey = defaultBackgroundUrls && !(lang in defaultBackgroundUrls) ? 'en' : lang;
    const loginwallConfig = remoteConfig.get('loginwall_config');
    const backgroundImageUrl = loginwallConfig?.backgroundImageUrl;
    const remoteTitle = loginwallConfig?.title;
    const remoteSubtitle = loginwallConfig?.subtitle;

    const title = remoteTitle?.[langKey];
    const subtitle = remoteSubtitle?.[langKey];
    const backgroundUrl = backgroundImageUrl?.[langKey] ?? defaultBackgroundUrls?.[langKey] ?? '';
    const loginwallShowcaseId = loginwallConfig?.loginwallShowcaseId;

    return {
        backgroundUrl,
        title,
        subtitle,
        loginwallShowcaseId,
        isLoginButtonEnabled: loginwallConfig?.isLoginButtonEnabled ?? true,
    };
};
